export default __webpack_public_path__ + "static/5-ce0e16bd63ddc2950e0d4691f4a51111.png";